import { ReactNode } from "react";

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description }) => {
  return (
    <div className="group relative bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
      <div className="absolute -top-3 -left-3 w-12 h-12 bg-gradient-to-br from-brand-blue to-blue-400 rounded-xl flex items-center justify-center text-white transform rotate-3 group-hover:rotate-6 transition-transform duration-300">
        {icon}
      </div>
      <div className="ml-6 mt-3">
        <h3 className="text-xl font-semibold mb-3 text-gray-900 dark:text-white">{title}</h3>
        <p className="text-gray-600 dark:text-gray-300 leading-relaxed">{description}</p>
      </div>
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-brand-blue to-blue-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 rounded-b-2xl" />
    </div>
  );
};

export const ProductCard = ({
  title,
  description,
  ctaText,
  ctaLink = "#",
  icon,
  onCtaClick,
}: {
  title: string;
  description: string;
  ctaText: string;
  ctaLink?: string;
  icon: ReactNode;
  onCtaClick?: () => void;
}) => {
  return (
    <div className="overflow-hidden transition-all duration-300 hover:shadow-xl bg-white dark:bg-gray-900 rounded-2xl shadow-lg">
      <div className="h-48 bg-gradient-to-br from-brand-blue to-blue-400 flex items-center justify-center p-6">
        <div className="w-24 h-24 text-white">{icon}</div>
      </div>
      <div className="p-8">
        <h3 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-white">{title}</h3>
        <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">{description}</p>
        <a href={ctaLink} onClick={onCtaClick} className="inline-flex items-center font-medium text-brand-blue hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300">
          {ctaText}
          <svg className="ml-2 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
              clipRule="evenodd"
            ></path>
          </svg>
        </a>
      </div>
    </div>
  );
};
